module.exports = __webpack_public_path__ + "assets/gluten_free-fbf479.svg";